import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIntegrationDentrix = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Dentrix Logo Small 1",
		clipPath: "url(#clip0_16956_72616)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M5.73868 0.311829H13.3171C17.4669 0.311829 20.0697 1.44075 21.6794 3.06096C23.2683 4.64981 24 6.72995 24 9.32228C24 12.5313 22.777 15.4582 20.4878 17.7474C17.9268 20.3188 14.2265 21.6881 9.28223 21.6881H0L5.73868 0.311829ZM10.0767 15.4582C12.2404 15.4582 14.1115 14.8205 15.2091 13.723C16.0976 12.8345 16.7352 11.4024 16.7352 10.0853C16.7352 8.92507 16.4007 8.162 15.8467 7.608C15.1777 6.93901 14.101 6.54179 12.3972 6.54179H11.2056L8.8223 15.4582H10.0767Z",
			fill: "#1E3667"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16956_72616",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 21.3763,
			fill: "white",
			transform: "translate(0 0.311829)"
		})
	}) })]
});
export default SvgIconIntegrationDentrix;
